const appendCountryId = (params, countryId) => {
  if (countryId != null && countryId !== "") {
    params.append("countryId", String(countryId));
  }
};

export const buildCustomerOrdersUrl = ({ uamId, verticalId, countryId }) => {
  const params = new URLSearchParams({
    uamId: String(uamId),
    verticalId: String(verticalId),
  });
  appendCountryId(params, countryId);
  return `/customerOrders?${params.toString()}`;
};

export const buildPunchOrderUrl = ({ uamId, verticalId, countryId }) => {
  const params = new URLSearchParams({
    uamId: String(uamId),
    verticalId: String(verticalId),
  });
  appendCountryId(params, countryId);
  return `/punchOrder?${params.toString()}`;
};

export const buildPaymentPreferenceUrl = ({
  orderId,
  countryId,
  switchToLoan = false,
}) => {
  const params = new URLSearchParams({
    order_id: String(orderId),
  });
  appendCountryId(params, countryId);
  if (switchToLoan) {
    params.append("switch_to_loan", "true");
  }
  return `/paymentPreference?${params.toString()}`;
};

export const buildEditPaymentsUrl = ({ orderId, countryId }) => {
  const params = new URLSearchParams({
    order_id: String(orderId),
  });
  appendCountryId(params, countryId);
  return `/editPayments?${params.toString()}`;
};
